const globalEvents = {
    Categories: {
        GLOBAL_ALERT: "GLOBAL_ALERT",
    },
    SubCategories: {
        PAGE_NOT_FOUND: "PAGE_NOT_FOUND",
        UNKNOWN_ERROR: "UNKNOWN_ERROR",
    },
};

const globalEventTypes = {
    Success: "alert-success",
    Warning: "alert-warning",
    Info: "alert-info",
    Danger: "alert-danger",
};

export { globalEvents, globalEventTypes };
